import styled from "styled-components";
import React, { useEffect, useState } from "react";
import { GridCoordinates, PlayArea } from "../PlayPanel.logic";
import PlayAreaComponent from "./PlayArea/PlayArea";
import { gridCoordinatesGet } from "./PlayAreas.logic";

type Props = {
  playAreas: PlayArea[];
};

const PlayAreas = ({ playAreas }: Props) => {
  const areas = [];
  for (let i = 0; i < playAreas.length; i++) {
    const playArea = playAreas[i];
    const gridCoordinates: GridCoordinates = gridCoordinatesGet(playArea.area);
    const areaId = "area_" + i;

    areas.push(
      <PlayAreaDiv key={areaId} id={areaId} $gridCoordinates={gridCoordinates}>
        <PlayAreaComponent playArea={playArea} areaInd={i} playMapInd={0} />
      </PlayAreaDiv>
    );
  }

  return <>{areas}</>;
};

const PlayAreaDiv = styled.div<{ $gridCoordinates: GridCoordinates }>`
  grid-column-start: ${(props) => props.$gridCoordinates.columnStart ?? 0};
  grid-column-end: ${(props) => props.$gridCoordinates.columnEnd ?? 0};
  grid-row-start: ${(props) => props.$gridCoordinates.rowStart ?? 0};
  grid-row-end: ${(props) => props.$gridCoordinates.rowEnd ?? 0};
`;

export default PlayAreas;
